<template>
    <div id="login" class="text-center">
        <b-container>
            <b-row align-v="center" align-h="center">
                <b-col cols="12" class="text-center">
                    <div>
                        <b-form @submit="onLogin" v-if="show" class="form-signin">
                            
                            <h3 class="h3 mb-3 font-weight-normal text-left"> 
                                 Login
                            </h3>

                            <h5 v-if="user && user.error">Usuário ou senha inválidos</h5>

                            <b-form-group label-for="input-1">
                                <b-form-input
                                id="input-1"
                                v-model="userData.username"
                                type="text"
                                required
                                placeholder="Enter username"
                                class="form-control"
                                ></b-form-input>
                            </b-form-group>

                            <b-form-group label-for="input-2">
                                <b-form-input
                                id="input-2"
                                v-model="userData.password"
                                type="password"
                                required
                                placeholder="Password"
                                class="form-control"
                                ></b-form-input>
                            </b-form-group>

                            <b-button type="submit" variant="primary" class="btn-block">Login</b-button>
                        </b-form>                     
                    </div>
                     <div class="text-center">
                        <router-link to="cadastro" style="color: rgba(255,255,255, .75)">Não possui conta ainda?</router-link>
                    </div>
                </b-col> 
            </b-row>
        </b-container>

    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Login',
    data() {
        return {
            userData: {
                username: '',
                password: ''
            },
            show: true
        }
    },
    methods:
        { 
            onLogin(evt) {
                if(this.userData.username === "nefroatlas" && this.userData.password === "nefroatlas"){
                    this.$router.push('/home')
                }
                this.$store.dispatch('login', this.userData);
                evt.preventDefault();
            },
        },
    computed: mapState(['user']),
    created() {}
}
</script>

<style scoped>
#input-1, #input-2 {
    border: none;
    border-bottom: 1px solid aqua;
}


#login {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  height: inherit;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

</style>
